import(/* webpackMode: "eager" */ "/app/src/app/rules/page.tsx")